import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { slideInDownAnimation } from '../../app/app.animation';
import { AngularMaterialService, ErrorParseService, IFormStatus, PermissionsService } from '../../commons';
import { Store } from '@ngrx/store';
import * as fromFormStatus from './state/form-status.selectors';
import * as FormStatusAction from './state/form-status.actions';
import * as lgeApp from '../../app/state/app.actions';
import * as _ from 'lodash';
import { Observable, skipWhile, Subscription } from 'rxjs';

@Component({
    selector: 'form-status-screen',
    templateUrl: 'form-status.component.html',
    styleUrls: ['form-status.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormStatusScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;

    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;

    @Input() openCGData$: Observable<IFormStatus | null>;
    openCGDataSubscription: Subscription;
    @Input() closedCGData$: Observable<IFormStatus | null>;
    closedCGDataSubscription: Subscription;

    @Input() openPPData$: Observable<IFormStatus | null>;
    openPPDataSubscription: Subscription;
    @Input() closedPPData$: Observable<IFormStatus | null>;
    closedPPDataSubscription: Subscription;

    @Input() openESData$: Observable<IFormStatus | null>;
    openESDataSubscription: Subscription;
    @Input() closedESData$: Observable<IFormStatus | null>;
    closedESDataSubscription: Subscription;

    // @Input() openFOData$: Observable<IFormStatus | null>;
    // openFODataSubscription: Subscription;
    // @Input() closedFOData$: Observable<IFormStatus | null>;
    // closedFODataSubscription: Subscription;
    // @Input() openCIData$: Observable<IFormStatus | null>;
    // openCIDataSubscription: Subscription;
    // @Input() closedCIData$: Observable<IFormStatus | null>;
    // closedCIDataSubscription: Subscription;

    stateData: IFormStatus | null;

    formCGOpenRequests: any;
    formCGClosedRequests: any;

    formPPOpenRequests: any;
    formPPClosedRequests: any;

    formESOpenRequests: any;
    formESClosedRequests: any;

    // formFOOpenRequests: any;
    // formFOClosedRequests: any;
    // formCIOpenRequests: any;
    // formCIClosedRequests: any;

    columnsCGPPOpenRequests = ['select', 'requestNo', 'projectName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'view'];
    columnsCGPPClosedRequests = ['select', 'requestNo', 'projectName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'emailDate', 'view'];

    columnsESOpenRequests = ['select', 'requestNo', 'eventName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'view'];
    columnsESClosedRequests = ['select', 'requestNo', 'eventName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'emailDate', 'view'];

    // columnsOpenRequests = ['select', 'requestNo', 'formName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'view'];
    // columnsClosedRequests = ['select', 'requestNo', 'formName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'emailDate', 'view'];

    constructor(
        private store: Store<fromFormStatus.State>,
        private ref: ChangeDetectorRef,
        private ams: AngularMaterialService,
        private permissionsService: PermissionsService,
        private errorParse: ErrorParseService
    ) {
        this.selectState();
    }

    ngOnInit() {
        this.startSubscriptions();
    }

    hasRole(role: string) {
        return this.permissionsService.hasRoles(role);
    }

    private selectState(): void {
        this.pending$ = this.store.select(fromFormStatus.getFormStatusScreenPending);
        this.error$ = this.store.select(fromFormStatus.getFormStatusScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));

        this.openCGData$ = this.store.select(fromFormStatus.getOpenCGData).pipe(skipWhile(data => data === undefined || data === null));
        this.closedCGData$ = this.store.select(fromFormStatus.getClosedCGData).pipe(skipWhile(data => data === undefined || data === null));

        this.openPPData$ = this.store.select(fromFormStatus.getOpenPPData).pipe(skipWhile(data => data === undefined || data === null));
        this.closedPPData$ = this.store.select(fromFormStatus.getClosedPPData).pipe(skipWhile(data => data === undefined || data === null));

        this.openESData$ = this.store.select(fromFormStatus.getOpenESData).pipe(skipWhile(data => data === undefined || data === null));
        this.closedESData$ = this.store.select(fromFormStatus.getClosedESData).pipe(skipWhile(data => data === undefined || data === null));

    }

    updateStatusDescription(data: any) {
        let result = data.map((value) => {
            switch (value.statusDescrAdmin) {
                case 'Negotiable':
                    value.statusDescrAdmin = 'Check Issued';
                    break;
                case 'Voided':
                    value.statusDescrAdmin = 'Check Voided';
                    break;
                case 'Cleared':
                    value.statusDescrAdmin = 'Check Cleared';
                    break;
                case 'Reconciled':
                    value.statusDescrAdmin = 'Check Cashed';
                    break;
            }
            return value;
        });

        return result;
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            setTimeout(() => {
                this.ams.showLoader('Loading...');
                this.ref.markForCheck();
            })
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, 'CORPCOMMONWS')) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert('Loading Error', errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new FormStatusAction.FormStatusScreenErrorReset());
        });
    }

    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }

    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });


        this.openCGDataSubscription = this.openCGData$
            .subscribe(stateData => {
                if (stateData !== undefined) {
                    let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
                    this.formCGOpenRequests = data;
                    this.ref.markForCheck();
                }
            });
        this.closedCGDataSubscription = this.closedCGData$
            .subscribe(stateData => {
                if (stateData !== undefined) {
                    let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
                    if (!this.hasRole('CITAPPROVER|ADMIN')) { // FOUNDATION APPROVER ONLY
                        data = _.filter(data, item => item.reassign === 'No');
                    } else if (!this.hasRole('FOUNDATIONAPPROVER|ADMIN')) // CITAPPROVER ONLY
                    {
                        data = _.filter(data, item => item.reassign === 'Yes');
                    }
                    this.formCGClosedRequests = data;
                    this.ref.markForCheck();
                }
            });

        this.openPPDataSubscription = this.openPPData$
            .subscribe(stateData => {
                if (stateData !== undefined) {
                    let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
                    this.formPPOpenRequests = data;
                    this.ref.markForCheck();
                }
            });
        this.closedPPDataSubscription = this.closedPPData$
            .subscribe(stateData => {
                if (stateData !== undefined) {
                    let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
                    this.formPPClosedRequests = data;
                    this.ref.markForCheck();
                }
            });

        this.openESDataSubscription = this.openESData$
            .subscribe(stateData => {
                if (stateData !== undefined) {
                    let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
                    this.formESOpenRequests = data;
                    this.ref.markForCheck();
                }
            });
        this.closedESDataSubscription = this.closedESData$
            .subscribe(stateData => {
                if (stateData !== undefined) {
                    let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
                    if (!this.hasRole('CITAPPROVER|ADMIN')) { // FOUNDATION APPROVER ONLY
                        data = _.filter(data, item => item.reassign === 'No');
                    } else if (!this.hasRole('FOUNDATIONAPPROVER|ADMIN')) // CITAPPROVER ONLY
                    {
                        data = _.filter(data, item => item.reassign === 'Yes');
                    }
                    this.formESClosedRequests = data;
                    this.ref.markForCheck();
                }
            });

        if (this.hasRole('ADMIN|CITAPPROVER|FOUNDATIONAPPROVER')) {
            this.store.dispatch(new FormStatusAction.LoadOpenFormCGState());
            this.store.dispatch(new FormStatusAction.LoadOpenFormESState());
        }
        if (this.hasRole('ADMIN|PFTPAPPROVER')) {
            this.store.dispatch(new FormStatusAction.LoadOpenFormPPState());
        }
        // if (this.hasRole('ADMIN|CITAPPROVER')) {
        //     this.store.dispatch(new FormStatusAction.LoadOpenFormCIState());
        // }
        // if (this.hasRole('ADMIN|FOUNDATIONAPPROVER')) {
        //     this.store.dispatch(new FormStatusAction.LoadOpenFormFOState());
        // }
    }

    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();

        this.openCGDataSubscription.unsubscribe();
        this.closedCGDataSubscription.unsubscribe();

        this.openPPDataSubscription.unsubscribe();
        this.closedPPDataSubscription.unsubscribe();

        this.openESDataSubscription.unsubscribe();
        this.closedESDataSubscription.unsubscribe();

        this.store.dispatch(new FormStatusAction.LoadInitFormStatusState());
        // this.openCIDataSubscription.unsubscribe();
        // this.closedCIDataSubscription.unsubscribe();
        // this.openFODataSubscription.unsubscribe();
        // this.closedFODataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }

}




// selectFormPPtoClose() {
//     const displayedColumns = ['select', 'requestNo', 'formName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'view'];
//     this.ams.showOpenRequestToClose('Plant for the Planet', this.formPPOpenRequests, displayedColumns);
//     this.ams.openRequest.afterClosed().subscribe(result => {
//         if (result) {
//             if (result.length > 0) {
//                 // console.log('selected requests to close');
//                 // console.log(result);
//                 this.ams.showLoader('Closing selected requests...');
//                 this._dataService.UpdateFormStatus_Close(result)
//                     .then((closeResult) => {
//                         this.ams.closeDialog();
//                         this.getOpenRequestFormPP();
//                         this.getClosedRequestFormPP();
//                         this.ref.markForCheck();
//                     }, error => {
//                         // console.log(error);
//                         this.ams.closeDialog();
//                         this.ams.showAlert('Error!', error.message);
//                         this.ref.markForCheck();
//                     });
//             }
//         }
//     });
// }

// selectFormFOtoClose() {
//     const displayedColumns = ['select', 'requestNo', 'reassign', 'formName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'view'];
//     this.ams.showOpenRequestToClose('LG&E KU Foundation', this.formFOOpenRequests, displayedColumns);
//     this.ams.openRequest.afterClosed().subscribe(result => {
//         if (result) {
//             if (result.length > 0) {
//                 // console.log('selected requests to close');
//                 // console.log(result);
//                 this.ams.showLoader('Closing selected requests...');
//                 this._dataService.UpdateFormStatus_Close(result)
//                     .then((closeResult) => {
//                         this.ams.closeDialog();
//                         // console.log(closeResult);
//                         this.getOpenRequestFormFO();
//                         this.getClosedRequestFormFO();
//                         this.ref.markForCheck();
//                     }, error => {
//                         this.ams.closeDialog();
//                         // console.log(error);
//                         this.ams.showAlert('Error!', error.message);
//                         this.ref.markForCheck();
//                     });
//             }
//         }
//     });
// }

// selectFormCItoClose() {
//     const displayedColumns = ['select', 'requestNo', 'reassign', 'formName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'view'];
//     this.ams.showOpenRequestToClose('Community Investment Funding', this.formCIOpenRequests, displayedColumns);
//     this.ams.openRequest.afterClosed().subscribe(result => {
//         if (result) {
//             if (result.length > 0) {
//                 // console.log('selected requests to close');
//                 // console.log(result);
//                 this.ams.showLoader('Closing selected requests...');
//                 this._dataService.UpdateFormStatus_Close(result)
//                     .then((closeResult) => {
//                         // console.log(closeResult);
//                         this.ams.closeDialog();
//                         this.getOpenRequestFormCI();
//                         this.getClosedRequestFormCI();
//                         this.ref.markForCheck();
//                     }, error => {
//                         // console.log(error);
//                         this.ams.showAlert('Error!', error.message);
//                         this.ref.markForCheck();
//                     });
//             }
//         }
//     });
// }

// selectFormCGtoClose() {
//     const displayedColumns = ['select', 'requestNo', 'formName', 'OrgName', 'dateRequest', 'status', 'statusDescrAdmin', 'view'];
//     this.ams.showOpenRequestToClose('Community Grants', this.formCGOpenRequests, displayedColumns);
//     this.ams.openRequest.afterClosed().subscribe(result => {
//         if (result) {
//             if (result.length > 0) {
//                 // console.log('selected requests to close');
//                 // console.log(result);
//                 this.ams.showLoader('Closing selected requests...');
//                 this._dataService.UpdateFormStatus_Close(result)
//                     .then((closeResult) => {
//                         // console.log(closeResult);
//                         this.ams.closeDialog();
//                         this.getOpenRequestFormCG();
//                         this.getClosedRequestFormCG();
//                         this.ref.markForCheck();
//                     }, error => {
//                         // console.log(error);
//                         this.ams.showAlert('Error!', error.message);
//                         this.ref.markForCheck();
//                     });
//             }
//         }
//     });
// }




// this.openCIDataSubscription = this.openCIData$
//     .subscribe(stateData => {
//         if (stateData !== undefined) {
//             let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
//             this.formCIOpenRequests = data;
//             this.ref.markForCheck();
//         }
//     });
// this.closedCIDataSubscription = this.closedCIData$
//     .subscribe(stateData => {
//         if (stateData !== undefined) {
//             let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
//             this.formCIClosedRequests = data;
//             this.ref.markForCheck();
//         }
//     });
// this.openFODataSubscription = this.openFOData$
//     .subscribe(stateData => {
//         if (stateData !== undefined) {
//             let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
//             this.formFOOpenRequests = data;
//             this.ref.markForCheck();
//         }
//     });
// this.closedFODataSubscription = this.closedFOData$
//     .subscribe(stateData => {
//         if (stateData !== undefined) {
//             let data = this.updateStatusDescription(JSON.parse(JSON.stringify(stateData)));
//             this.formFOClosedRequests = data;
//             this.ref.markForCheck();
//         }
//     });